export default "__VITE_ASSET__BHOFRaoV__"